<script lang="ts">
  import { BUILD_INFO as CONSOLE_BUILD } from '$lib/build-info.generated';
  import { onMount } from 'svelte';
  import { popover } from '$lib/a11y/dismissible';
  import { identity } from '$lib/state/identity.svelte';

  type WorkerBuild = {
    branch: string;
    sha: string;
    sha_short: string;
    built_at: string;
    commit_time: string;
  };

  let cpBuild: WorkerBuild | null = $state(null);
  let expanded = $state(false);

  onMount(async () => {
    try {
      const r = await fetch('/__build', { credentials: 'include' });
      if (r.ok) cpBuild = (await r.json()) as WorkerBuild;
    } catch {
      // Network error — leave cpBuild as null; pill still shows console build.
    }
  });

  function fmt(iso: string): string {
    if (iso === 'unknown') return iso;
    try {
      return new Date(iso).toISOString().replace('T', ' ').slice(0, 19) + ' UTC';
    } catch {
      return iso;
    }
  }
</script>

<button
  type="button"
  class="fixed bottom-3 left-3 text-xs bg-zinc-100 hover:bg-zinc-200 border border-zinc-300 rounded-full px-3 py-1 font-mono shadow-sm z-50"
  onclick={() => (expanded = !expanded)}
  aria-haspopup="dialog"
  aria-expanded={expanded}
  aria-label="Build info"
>
  {CONSOLE_BUILD.sha_short} · cp {cpBuild?.sha_short ?? '?'}
</button>

{#if expanded}
  <div
    class="fixed bottom-12 left-3 right-3 sm:right-auto sm:min-w-[20rem] sm:max-w-sm bg-white border border-zinc-300 rounded shadow-lg p-3 text-xs font-mono z-50"
    role="dialog"
    aria-label="Build details"
    tabindex="-1"
    {@attach popover({ onClose: () => (expanded = false), autoFocus: false })}
  >
    <div class="font-sans font-semibold text-zinc-700 mb-2">Build info</div>
    <div class="grid grid-cols-2 gap-x-3 gap-y-1">
      <div class="text-zinc-500">console branch</div>
      <div>{CONSOLE_BUILD.branch}</div>
      <div class="text-zinc-500">console sha</div>
      <div>{CONSOLE_BUILD.sha_short}</div>
      <div class="text-zinc-500">console built</div>
      <div>{fmt(CONSOLE_BUILD.built_at)}</div>
      <div class="border-t border-zinc-200 col-span-2 my-1"></div>
      <div class="text-zinc-500">cp branch</div>
      <div>{cpBuild?.branch ?? '—'}</div>
      <div class="text-zinc-500">cp sha</div>
      <div>{cpBuild?.sha_short ?? '—'}</div>
      <div class="text-zinc-500">cp built</div>
      <div>{cpBuild ? fmt(cpBuild.built_at) : '—'}</div>
    </div>
    {#if identity.value?.user_class === 'member' && identity.value.platform_admin}
      <a href="/admin/about" class="block mt-2 text-blue-600 hover:underline">Full details →</a>
    {/if}
  </div>
{/if}
